import * as Yup from "yup";

export const salevalidationSchema = () =>
  Yup.object().shape({
    // customerName: Yup.string()
    //   .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters and spaces")
    //   .min(2, "Name must be at least 2 characters")
    //   .max(50, "Name must be at most 50 characters")
    //   .required(<span className='text-xs'>Name is required</span>),
    mobile: Yup.string()
      .required(<span className='text-xs'>Mobile is required</span>)
      .min(10, "Number must be at least 10 digits")
      .max(15, "Number must be at most 10 digits"),
    gstNo: Yup.string().matches(
      /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})$/,
      "Invalid GST IN"
    ),
    pickupDate: Yup.string().when("saleType", {
      is: "schedulePickup",
      then: Yup.string()
        .required(<span className='text-xs'>Pickup Date is Required</span>)
        .test(
          "is-future-date",
          "Pickup Date cannot be a past date",
          function (value) {
            if (!value) return false;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const pickupDate = new Date(value);
            return pickupDate >= today;
          }
        ),
    }),
  });

export const purchaseValidationSchema = Yup.object().shape({
  // fullName: Yup.string()
  //   .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters and spaces")
  //   .min(2, "Name must be at least 2 characters")
  //   .max(50, "Name must be at most 50 characters")
  //   .required(<span className='text-xs'>Name is required</span>),
  supplierMobile: Yup.string()
    // .matches(/^[0-9]{10}$/, "Invalid mobile number")
    .min(10, "Number must be at least 10 digits")
    .max(15, "Number must be at most 10 digits")
    .required(<span className='text-xs'>Mobile is required</span>),
  // intimationDate: Yup.string().required("Date is required"),
  // expectedDate: Yup.string().required("Expected Delivery Date is required"),
});

export const validationSchemaCashbook = Yup.object().shape({
  amount: Yup.string()
    // .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters and spaces")
    // .min(2, "Name must be at least 2 characters")
    // .max(50, "Name must be at most 50 characters")
    .required(<span className='text-xs dark:text-red-500'>Amount is required</span>),

  // supplierMobile: Yup.string()
  //   .matches(/^[0-9]{10}$/, "Invalid mobile number")
  //   .required(<span className='text-xs'>Mobile is required</span>),
  // intimationDate: Yup.string().required("Date is required"),
  // expectedDate: Yup.string().required("Expected Delivery Date is required"),
});
